module.exports = __webpack_public_path__ + "img/success.a23b7c91.png";